import styled from 'styled-components';
import { color, getBackgroundColor, getTextColor } from '@magalu/stereo-ui-styles';
import { space } from 'styled-system';
import Logo from '../../atoms/Logo';
import { WishlistCounterButton, ShoppingBagButton } from '../../molecules';
import { Strip, Link } from '../../atoms';
export const HeaderContainer = styled.header.attrs(props => Object.assign({
  bg: 'background.primary',
  px: 2
}, props))`
  display: flex;
  justify-content: center;
  width: 100%;
  ${color}
  ${space}
`;
export const HeaderContent = styled.div`
  width: 100%;
  /* TODO: USE A THEME SETTING HERE */
  max-width: 1366px;
  position: relative;
  display: grid;
  grid-template-columns: 95px 140px 1fr;
  grid-template-areas:
    '. . links'
    'lu logo widgets'
    'lu menus menus'
    'strip strip strip';
`;
export const LuContainer = styled(Link)`
  grid-area: lu;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;
export const LogoContainer = styled(Link).attrs(props => Object.assign({
  mr: 3
}, props))`
  grid-area: logo;
  display: flex;
  align-items: center;
  cursor: pointer;

  /* Fine tuning: this padding aligns the logo with the search bar vertically */
  padding-bottom: 8px;

  ${space}
`;
export const StyledLogo = styled(Logo).attrs(() => ({
  width: 138,
  height: 30
}))``;
export const LinksContainer = styled.div.attrs(props => Object.assign({
  my: 3
}, props))`
  grid-area: links;
  display: flex;
  justify-content: space-between;
  ${space}
`;
export const WidgetsContainer = styled.div.attrs(props => Object.assign({
  mb: 3
}, props))`
  grid-area: widgets;
  display: flex;
  align-items: center;

  ${space}
`;
export const SearchInputContainer = styled.div`
  flex-grow: 1;
  margin-top: ${props => props.hasSibling ? '25px;' : '0px;'};
`;
export const StyledWishlistCounterButton = styled(WishlistCounterButton).attrs(props => Object.assign({
  backgroundColor: getBackgroundColor('primary')(props),
  iconColor: getTextColor('white')(props),
  fontColor: getTextColor('white')(props),
  counterColor: '#db44a7'
}, props))``;
export const StyledShoppingBagButton = styled(ShoppingBagButton).attrs(props => Object.assign({
  backgroundColor: getBackgroundColor('primary')(props),
  iconColor: getTextColor('white')(props),
  fontColor: getTextColor('white')(props),
  counterColor: '#58c22e'
}, props))``;
export const MenusContainer = styled.div`
  width: 100%;
  grid-area: menus;
`;
export const LoggedAreaContainer = styled.div.attrs(props => Object.assign({
  mx: 3
}, props))`
  width: 150px;
  ${space}
`;
export const ButtonContainer = styled(Link).attrs(props => Object.assign({
  mx: 1
}, props))`
  height: 45px;
  width: 60px;
  ${space}
`;
export const StyledStrip = styled(Strip).attrs(props => Object.assign({}, props))`
  grid-area: strip;
`;